<template>
  <div class="real-name-review">
    <el-card shadow="never">
      <div class="search-area">
        <el-form :inline="true" :model="query" class="search-form" @submit.native.prevent>
          <el-form-item label="审核结果">
            <el-select
              v-model="query.status"
              placeholder="请选择"
              clearable
              style="width: 160px"
              @change="onStatusFilterChange"
            >
              <el-option label="全部" value="" />
              <el-option label="待审核" value="PENDING" />
              <el-option label="已通过" value="APPROVED" />
              <el-option label="未通过" value="NONE" />
            </el-select>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input
              v-model="query.keyword"
              maxlength="50"
              show-word-limit
              clearable
              placeholder="请输入姓名、身份证号"
              style="width: 260px"
            />
          </el-form-item>
          <el-form-item label="提交时间">
            <el-date-picker
              v-model="query.submitRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              clearable
              style="width: 380px"
            />
          </el-form-item>
          <el-form-item label="审核时间">
            <el-date-picker
              v-model="query.reviewRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              clearable
              style="width: 380px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSearchClick">查询</el-button>
            <el-button icon="el-icon-refresh" @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="btn-group">
          <img
            class="toolbar-back-icon"
            src="@/static/iconImage/reback-icon-64.png"
            alt="返回首页"
            title="返回首页"
            @click="onBackDashboard"
          />
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="list-card">
      <el-row type="flex" :gutter="12" class="list-row">
        <el-col v-for="item in list" :key="item.snapshotId || item.staffId" :span="12" class="list-col">
          <el-card class="review-card" shadow="hover">
            <img
              v-if="normalize(item.realNameVerifyStatus) === 'APPROVED'"
              class="review-card__corner-stamp"
              src="@/static/iconImage/has_pass-icon-48.png"
              alt="已通过"
            />
            <img
              v-else-if="normalize(item.realNameVerifyStatus) === 'NONE'"
              class="review-card__corner-stamp"
              src="@/static/iconImage/has-not-pass-icon-48.png"
              alt="未通过"
            />
            <div class="head">
              <span class="name">{{ displaySubmitterName(item.submitterName) }}</span>
            </div>
            <div class="line line--identity">
              <span class="id-meta"><span class="id-meta__k">姓名</span>：{{ item.realName || '-' }}</span>
              <span class="id-meta-sep">·</span>
              <span class="id-meta"><span class="id-meta__k">身份证号</span>：{{ item.idCardNo || '-' }}</span>
              <span class="id-meta-sep">·</span>
              <span class="id-meta"><span class="id-meta__k">提交时间</span>：{{ item.realNameSubmittedAt || '-' }}</span>
            </div>
            <div class="review-card__divider" role="separator" aria-hidden="true" />
            <div class="line line--audit">审核人：{{ item.realNameReviewerName || '-' }}</div>
            <div class="line line--audit">审核时间：{{ item.realNameReviewedAt || '-' }}</div>
            <div class="img-row">
              <div
                class="img-shell"
                :style="zoomShellStyle(item, 'front')"
                @mousemove="onImgMove(item, 'front', $event)"
                @mouseleave="onImgLeave(item, 'front')"
              >
                <el-image
                  class="img"
                  :src="item.idCardFrontUrl"
                  fit="cover"
                  :preview-src-list="buildPreviewList(item)"
                  :initial-index="0"
                />
              </div>
              <div
                class="img-shell"
                :style="zoomShellStyle(item, 'back')"
                @mousemove="onImgMove(item, 'back', $event)"
                @mouseleave="onImgLeave(item, 'back')"
              >
                <el-image
                  class="img"
                  :src="item.idCardBackUrl"
                  fit="cover"
                  :preview-src-list="buildPreviewList(item)"
                  :initial-index="1"
                />
              </div>
            </div>
            <div v-if="item.realNameRejectReason" class="reason-block">
              <div class="reason-block__label">不通过原因</div>
              <div class="reason-block__body">{{ item.realNameRejectReason }}</div>
            </div>
            <div v-if="normalize(item.realNameVerifyStatus) === 'PENDING'" class="action-row">
              <img
                class="action-icon"
                src="@/static/iconImage/pass-icon-48.png"
                alt="通过"
                title="通过"
                @click.stop="onApprove(item)"
              />
              <img
                class="action-icon"
                src="@/static/iconImage/not-pass-icon-48.png"
                alt="不通过"
                title="不通过"
                @click.stop="onOpenReject(item)"
              />
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>

    <div class="pagination-wrapper">
      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="query.pageSize"
        :current-page.sync="query.page"
        :page-sizes="[10, 20, 50]"
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
      />
    </div>

    <el-dialog title="不通过原因" :visible.sync="rejectDialogVisible" width="520px">
      <el-input
        type="textarea"
        v-model="rejectReason"
        :rows="5"
        maxlength="200"
        show-word-limit
        placeholder="请输入不通过原因（最多200字）"
      />
      <span slot="footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onRejectSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'RealNameReview',
  data() {
    return {
      list: [],
      total: 0,
      query: {
        status: 'PENDING',
        page: 1,
        pageSize: 10,
        keyword: '',
        submitRange: null,
        reviewRange: null
      },
      rejectDialogVisible: false,
      rejectReason: '',
      currentRejectItem: null,
      zoomMap: {}
    };
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearchClick() {
      if (!this.validateDatetimeRange(this.query.submitRange, '提交')) return;
      if (!this.validateDatetimeRange(this.query.reviewRange, '审核')) return;
      this.query.page = 1;
      this.onSearch();
    },
    onReset() {
      this.query.status = 'PENDING';
      this.query.page = 1;
      this.query.pageSize = 10;
      this.query.keyword = '';
      this.query.submitRange = null;
      this.query.reviewRange = null;
      this.onSearch();
    },
    onStatusFilterChange() {
      this.query.page = 1;
      if (!this.validateDatetimeRange(this.query.submitRange, '提交')) return;
      if (!this.validateDatetimeRange(this.query.reviewRange, '审核')) return;
      this.onSearch();
    },
    onPageSizeChange(size) {
      this.query.pageSize = size;
      this.query.page = 1;
      if (!this.validateDatetimeRange(this.query.submitRange, '提交')) return;
      if (!this.validateDatetimeRange(this.query.reviewRange, '审核')) return;
      this.onSearch();
    },
    onPageChange() {
      if (!this.validateDatetimeRange(this.query.submitRange, '提交')) return;
      if (!this.validateDatetimeRange(this.query.reviewRange, '审核')) return;
      this.onSearch();
    },
    normalize(v) {
      return String(v || 'NONE').toUpperCase();
    },
    /** 名称字段若含后端/历史拼接的实名状态后缀，展示时去掉 */
    displaySubmitterName(raw) {
      let s = String(raw ?? '').trim();
      if (!s) return '-';
      const patterns = [
        /\s*【已实名】\s*$/u,
        /\s*\[已实名\]\s*$/u,
        /\s*【未实名】\s*$/u,
        /\s*\[未实名\]\s*$/u,
        /\s*【审核中】\s*$/u,
        /\s*\[审核中\]\s*$/u,
        /\s*【已通过】\s*$/u,
        /\s*\[已通过\]\s*$/u,
        /\s*【未通过】\s*$/u,
        /\s*\[未通过\]\s*$/u
      ];
      for (let i = 0; i < patterns.length; i += 1) {
        s = s.replace(patterns[i], '').trim();
      }
      return s || '-';
    },
    getZoomKey(item, side) {
      return `${item.snapshotId || item.staffId || 'x'}-${side}`;
    },
    buildPreviewList(item) {
      const arr = [];
      if (item && item.idCardFrontUrl) arr.push(item.idCardFrontUrl);
      if (item && item.idCardBackUrl) arr.push(item.idCardBackUrl);
      return arr;
    },
    onImgMove(item, side, evt) {
      const key = this.getZoomKey(item, side);
      const target = evt && evt.currentTarget ? evt.currentTarget : null;
      if (!target) return;
      const rect = target.getBoundingClientRect();
      if (!rect || !rect.width || !rect.height) return;
      const x = Math.max(0, Math.min(100, ((evt.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((evt.clientY - rect.top) / rect.height) * 100));
      this.$set(this.zoomMap, key, { active: true, x, y });
    },
    onImgLeave(item, side) {
      const key = this.getZoomKey(item, side);
      const old = this.zoomMap[key] || {};
      this.$set(this.zoomMap, key, { active: false, x: old.x || 50, y: old.y || 50 });
    },
    zoomShellStyle(item, side) {
      const key = this.getZoomKey(item, side);
      const z = this.zoomMap[key] || { active: false, x: 50, y: 50 };
      return {
        '--zoom-x': `${z.x}%`,
        '--zoom-y': `${z.y}%`
      };
    },
    validateDatetimeRange(range, label) {
      if (!range || !Array.isArray(range) || range.length !== 2) return true;
      const a = String(range[0] || '').trim();
      const b = String(range[1] || '').trim();
      if (!a && !b) return true;
      if (!a || !b) return true;
      const t0 = new Date(a.replace(/-/g, '/')).getTime();
      const t1 = new Date(b.replace(/-/g, '/')).getTime();
      if (Number.isNaN(t0) || Number.isNaN(t1)) {
        this.$message.warning(`${label}时间格式不正确`);
        return false;
      }
      if (t1 < t0) {
        this.$message.warning(`${label}结束时间不能早于开始时间`);
        return false;
      }
      const maxMs = 365 * 86400000;
      if (t1 - t0 > maxMs) {
        this.$message.warning(`${label}时间范围不能超过365天`);
        return false;
      }
      return true;
    },
    /** 提交时间降序；无/无效时间排后，同秒用 snapshotId 稳定次序 */
    parseRealNameSubmittedMs(s) {
      if (s == null || String(s).trim() === '') return NaN;
      const t = new Date(String(s).replace(/-/g, '/')).getTime();
      return Number.isNaN(t) ? NaN : t;
    },
    compareRealNameCardBySubmitDesc(a, b) {
      const ta = this.parseRealNameSubmittedMs(a && a.realNameSubmittedAt);
      const tb = this.parseRealNameSubmittedMs(b && b.realNameSubmittedAt);
      const na = Number.isNaN(ta);
      const nb = Number.isNaN(tb);
      if (na && nb) return 0;
      if (na) return 1;
      if (nb) return -1;
      if (tb !== ta) return tb - ta;
      const sa = String((a && a.snapshotId) || '');
      const sb = String((b && b.snapshotId) || '');
      return sb.localeCompare(sa);
    },
    buildListPayload() {
      const q = this.query;
      const body = {
        page: q.page,
        pageSize: q.pageSize,
        status: q.status,
        keyword: String(q.keyword || '')
          .trim()
          .slice(0, 50)
      };
      if (Array.isArray(q.submitRange) && q.submitRange.length === 2 && q.submitRange[0] && q.submitRange[1]) {
        body.submitAtStart = q.submitRange[0];
        body.submitAtEnd = q.submitRange[1];
      }
      if (Array.isArray(q.reviewRange) && q.reviewRange.length === 2 && q.reviewRange[0] && q.reviewRange[1]) {
        body.reviewAtStart = q.reviewRange[0];
        body.reviewAtEnd = q.reviewRange[1];
      }
      return body;
    },
    async onSearch() {
      if (!this.validateDatetimeRange(this.query.submitRange, '提交')) return;
      if (!this.validateDatetimeRange(this.query.reviewRange, '审核')) return;
      try {
        const res = await api.post('/staff/real-name/review/list', this.buildListPayload());
        const data = (res && res.data && res.data.data) || {};
        const raw = Array.isArray(data.list) ? data.list : [];
        this.list = raw.slice().sort((a, b) => this.compareRealNameCardBySubmitDesc(a, b));
        this.total = Number(data.total || 0);
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '加载列表失败';
        this.$message.error(msg);
      }
    },
    async onApprove(item) {
      await api.post('/staff/real-name/review/decide', {
        staffId: item.staffId,
        decision: 'APPROVED'
      });
      this.$message.success('审核已通过');
      this.onSearch();
    },
    onOpenReject(item) {
      this.currentRejectItem = item;
      this.rejectReason = '';
      this.rejectDialogVisible = true;
    },
    onBackDashboard() {
      this.$router.push({ name: 'Dashboard' });
    },
    async onRejectSubmit() {
      const reason = String(this.rejectReason || '').trim();
      if (!reason) {
        this.$message.warning('请填写不通过原因');
        return;
      }
      if (reason.length > 200) {
        this.$message.warning('不通过原因最多200字');
        return;
      }
      await api.post('/staff/real-name/review/decide', {
        staffId: this.currentRejectItem.staffId,
        decision: 'REJECTED',
        rejectReason: reason
      });
      this.$message.success('已驳回');
      this.rejectDialogVisible = false;
      this.onSearch();
    }
  }
};
</script>

<style scoped>
.real-name-review {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding-bottom: 56px;
}

.search-area {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
}

.search-form {
  flex: 1;
}

.btn-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toolbar-back-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.toolbar-back-icon:hover {
  transform: scale(1.2);
}

.list-card {
  margin-top: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.list-card >>> .el-card__body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 16px 20px;
}

.list-row {
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
  align-items: stretch;
}
.list-row >>> .list-col {
  display: flex;
  align-items: stretch;
  margin-bottom: 12px;
}
/* 角标绝对定位参照整个卡片（.el-card），不单独参照 body，避免跑出卡片视觉区域 */
.review-card {
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: visible;
}
.review-card >>> .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.review-card >>> .el-card__body > * {
  flex-shrink: 0;
}
.review-card__corner-stamp {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  width: auto;
  height: auto;
  display: block;
  pointer-events: none;
}
.head {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}
.name {
  font-size: 16px;
  font-weight: 700;
}
.line {
  font-size: 13px;
  line-height: 1.7;
  color: #606266;
}
.line--identity {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 8px;
  margin-bottom: 0;
}
/* 虚线：用平铺 SVG 而非 1px 高的 linear-gradient，避免亚像素对齐导致不同卡片上粗细观感不一致 */
.review-card__divider {
  margin: 12px 0 10px;
  height: 1px;
  border: 0;
  flex-shrink: 0;
  background-repeat: repeat-x;
  background-position: 0 50%;
  background-size: 28px 1px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='1' viewBox='0 0 28 1'%3E%3Crect width='12' height='1' fill='%23c0c4cc' fill-opacity='0.4'/%3E%3C/svg%3E");
}
.id-meta__k {
  color: #909399;
  font-weight: 500;
}
.id-meta-sep {
  color: #c0c4cc;
  user-select: none;
}
.line--audit {
  color: #909399;
  font-size: 12px;
  line-height: 1.65;
}
.reason-block {
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: rgba(245, 108, 108, 0.06);
  border: 1px solid rgba(245, 108, 108, 0.2);
}
.reason-block__label {
  font-size: 12px;
  font-weight: 600;
  color: #f56c6c;
  margin-bottom: 6px;
}
/* 限制高度，长文案在区域内滚动，避免单卡过高；与同行另一张卡仍靠 flex 拉齐总高 */
.reason-block__body {
  font-size: 13px;
  line-height: 1.65;
  color: #606266;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: calc(1.65em * 3);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.img-row {
  padding-top: 8px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.img-shell {
  width: min(100%, 350px);
  aspect-ratio: 85.6 / 54;
  overflow: hidden;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #f7f8fa;
  position: relative;
}
.img {
  width: 100%;
  height: 100%;
}
.img-shell >>> .el-image {
  width: 100%;
  height: 100%;
}
.img-shell >>> .el-image__inner {
  width: 100%;
  height: 100%;
  transition: transform 0.18s ease;
  transform-origin: var(--zoom-x, 50%) var(--zoom-y, 50%);
}
.img-shell:hover >>> .el-image__inner {
  transform: scale(1.85);
  cursor: zoom-in;
}
.action-row {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 18px;
}
.action-icon {
  width: 30px;
  height: 30px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.action-icon:hover {
  transform: scale(1.2);
}
</style>
